module.exports = __webpack_public_path__ + "static/img/logo1.4ec1d893.png";